import { Col, Container, Row } from "react-bootstrap";
import annexationScreenshot from "../../Assets/annexation-main.gif";

function Spotlight() {
  return (
    <Container fluid className="section">
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            style={{
              justifyContent: "center",
              paddingTop: "30px",
            }}
          >
            <h1 style={{ fontSize: "2.6em" }}>
              <a href="/annexation">Annexation</a>
            </h1>
            <p className="spotlight-body">
              Jump into <i><b>high octane strategy</b></i> and customize your army in this new Action Real-Time Strategy game exploring the source of the demonic Rot afflicting the lands of Endralus.
            </p>
          </Col>
          <Col>
            <img src={annexationScreenshot} className="img-fluid" alt="annexation" />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Spotlight;
